import { Step } from 'react-joyride';

export enum ActivityFeedJoyrideTarget {
  RESEARCH_TAB = 'joyrideTargetResearchTab',
  MEMBERS_TAB = 'joyrideTargetMembersTab',
  BUYSIDE_CONSENSUS = 'joyrideTargetBuysideConsensus',
  TRENDING_RESEARCH = 'joyrideTargetTrendingResearch'
}

export const activityFeedJoyrideSteps: {
  researchTab: Step;
  membersTab: Step;
  trendingResearch: Step;
} = {
  researchTab: {
    title: 'Research Tab',
    target: `[data-joyride-target="${ActivityFeedJoyrideTarget.RESEARCH_TAB}"]`,
    placement: 'right',
    content: 'Find investment ideas and research contests under the Research tab.',
    disableBeacon: true,
    disableOverlay: true,
    disableScrolling: true
  },
  membersTab: {
    title: 'Members Tab',
    target: `[data-joyride-target="${ActivityFeedJoyrideTarget.MEMBERS_TAB}"]`,
    placement: 'right',
    content: 'Use the Members tab to curate your network and follow Top Ranked Members.',
    disableBeacon: true,
    disableOverlay: true,
    disableScrolling: true
  },
  trendingResearch: {
    title: 'Trending Research',
    target: `[data-joyride-target="${ActivityFeedJoyrideTarget.TRENDING_RESEARCH}"]`,
    placement: 'left-start',
    content: 'See what ideas are trending across the community!'
  }
};
